<template>
  <div>
    <div v-if="!localGadget">
        <span>Loading...</span>
    </div>

    <form-container v-else :title="deviceLabel">

      <form-text-area 
              style="margin-top: 3rem"
              v-model="deviceDescription" 
              id="specification" 
              validationFieldLabel="specification" 
              :maxLength="500" 
              label="Colour / memory / specification of the gadget (500 characters or less)"
              validationInvalidFeedback="Please provide details of the gadgets specification etc."
              rows="5"></form-text-area>

      <div v-if="gadgetTypePhone"> <!-- Phone -->
        
        <form-imei id="newIMEI" v-model="newIMEI"></form-imei>        

        <form-sim v-if="false" v-model="simObj"></form-sim>

        <label for="provider">Network provider</label>
        <select id="provider" fieldlabel="Network provider" class="form-control form-control-lg" v-model="networkProviderId" v-taurus-validator="'required'" >
            <option :value="null">
                SELECT...
            </option>
            <option
                v-for="(option, index) in networkProviders"
                :key="'networkProvider_' + index" :value="option.id">
                {{option.label}}
            </option>
        </select>
        <div name="provider" invalidfeedback="Please select your network provider"></div>

        <label for="contract">Contract type</label>
        <select id="contract" fieldlabel="Contract type" v-model="contractTypeId" v-taurus-validator="'required'" class="form-control form-control-lg" >
            <option :value="null">
                SELECT...
            </option>
            <option
                v-for="(option, index) in contractTypes"
                :key="'contractType_' + index" :value="option.id">
                {{option.label}}
            </option>
        </select>
        <div name="contract" invalidfeedback="Please select your contract type"></div>
      </div> <!-- Phone -->

      <div v-if="!gadgetTypePhone"> <!-- Other devices -->
        <label for="serial">Serial</label>
        <input type="text" id="serial" fieldlabel="Serial" v-model="deviceSerial" v-taurus-validator="'required'" class="form-control form-control-lg" >
        <div name="serial" invalidfeedback="Please enter the gadgets serial number"></div>
      </div> <!-- Other devices -->

      <label for="purchaseDate">Date gadget purchased</label>
      <datepicker id="purchaseDate" 
                  fieldlabel="Purchase date" 
                  :format="customDateFormatter" 
                  v-model="devicePurchaseDate" 
                  :disabled-dates="disabledDatesInFuture()" 
                  v-taurus-validator="'required'" />
      <div name="purchaseDate" invalidfeedback="Please enter the date the gadget was purchased in the following format DD/MM/YYYY"></div>

      <label for="purchasedFrom">Gadget purchased from</label>
      <input type="text" 
             class="form-control form-control-lg" 
             id="purchasedFrom" 
             fieldlabel="Purchased from" 
             v-model="devicePurchaseLocation" 
             v-taurus-validator="'required'"
             >
      <div name="purchasedFrom" invalidfeedback="Please enter details of where the gadget was purchased from"></div>

      <form-yes-no-radio-list 
          class="bumper"
          id="purchasedByPolicyHolder" 
          v-model="purchasedByPolicyHolder" 
          label="Did you purchase the gadget?"
          validationFieldLabel="purchasedByPolicyHolder"
          validationInvalidFeedback="Please indicate whether you purchased the gadget">
        </form-yes-no-radio-list>

      
    <transition name="fade">
      <div v-if="purchasedByPolicyHolder != null && !purchasedByPolicyHolder"> <!-- Purchsed by -->
        <label for="purchasedBy">Gadget purchased by (if you answered No above)</label>
        <input type="text" 
               id="purchasedBy" 
               class="form-control form-control-lg" 
               fieldlabel="Purchased By" 
               v-model="purchasedBy" 
               v-taurus-validator="'required_if:purchasedByPolicyHolder,false'" >
        <div name="purchasedBy" invalidfeedback="Please provide details of the person who purchased the gadget"></div>
        
        <label for="relationship">Their relationship to you (if you answered NO above)</label>
        <select id="relationship" 
                class="form-control form-control-lg" 
                fieldlabel="Relationship" 
                v-model="relationshipTypeId" 
                v-taurus-validator="'required_if:purchasedByPolicyHolder,false'" >
            <option>
                SELECT...
            </option>
            <option
                v-for="(option, index) in relationshipTypes"
                :key="'relationshipType_' + index" :value="option.id">
                {{option.label}}
            </option>
        </select>
        <div name="relationship" invalidfeedback="Please indicate their relationship to you"></div>
        
      </div> <!-- Purchsed by -->
    </transition>

    <label for="purchaseType">Was the gadget purchased...</label>
    <select id="purchaseType" fieldlabel="Purchase Type" v-model="purchaseTypeId" v-taurus-validator="'required'" class="form-control form-control-lg" >
        <option :value="null">
            SELECT...
        </option>
       <option
            v-for="(option, index) in purchaseTypes"
            :key="'purchaseType_' + index" :value="option.id">
            {{option.label}}
        </option>
    </select>
    <div name="purchaseType" invalidfeedback="Please select the type of gadget purchased or whether it was a gift"></div>

    <div v-if="incidentTypeADOrMB"> <!-- AD + MB -->
      <!-- <div v-show="(damageTypes && damageTypes.length > 1) && (selectedDamageTypes && selectedDamageTypes.length > 0)"> -->
      <form-gadget-damage-check-list 
      class="bumper"
        id="damageTypes"
        label="Please indicate the type of damage (select all that apply)"
        :values="damageTypes"
        v-model="selectedDamageTypes"
        validationFieldLabel="damageTypes"
        validationInvalidFeedback="Please select at least one from the above"
        :validators="'required'">
      </form-gadget-damage-check-list>

      <form-text-area 
              style="margin-top: 3rem"
              v-model="damageDescription" 
              id="damageDescription" 
              validationFieldLabel="damageDescription" 
              :maxLength="500" 
              label="Describe the damage (500 characters or less)"
              validationInvalidFeedback="Please provide information about the damage"
              rows="5"></form-text-area>


        <form-yes-no-radio-list 
          class="bumper"
          id="deviceSwitchOn" 
          v-model="deviceSwitchOn" 
          label="Does the gadget switch on?"
          validationFieldLabel="deviceSwitchOn"
          validationInvalidFeedback="Please indicate whether the gadget still switches on">
        </form-yes-no-radio-list>

      

      <form-yes-no-radio-list 
          class="bumper"
          id="deviceLayFlat" 
          v-model="deviceLayFlat" 
          label="Does the gadget lay flat when placed on a  flat surface?"
          validationFieldLabel="deviceLayFlat"
          validationInvalidFeedback="Please indicate whether the gadget lays flat when placed on a level surface">
        </form-yes-no-radio-list>
      
    </div> <!-- AD + MB -->
    
    
    
    <div v-if="!incidentTypeADOrMB"> <!-- TL -->

      <form-text-area 
              style="margin-top: 0.5rem"
              v-model="deviceLocation" 
              id="deviceLocation" 
              validationFieldLabel="deviceLocation" 
              :maxLength="500" 
              label="Where was the gadget when the incident happened?"
              validationInvalidFeedback="Please provide information about where the gadget was when the incident happened limited to 500 characters."
              rows="5"></form-text-area>
    
        <form-yes-no-radio-list 
          class="bumper"
          id="deviceBlacklistRequested" 
          v-model="deviceBlacklistRequested" 
          label="Have you requested that the device be blacklisted?"
          validationFieldLabel="deviceBlacklistRequested"
          validationInvalidFeedback="Please indicate whether you have requested the gadget to be blacklisted">
        </form-yes-no-radio-list>

      
      
      
      <transition name="fade" mode="in-out">
        <div v-if="deviceBlacklistRequested === true">
          <label for="blacklistedDate">Date of the blacklist request</label>
          <datepicker id="blacklistedDate" 
                      fieldlabel="Blacklisted date" 
                      :format="customDateFormatter" 
                      v-model="deviceBlacklistDate" 
                      :disabled-dates="disabledDatesInFuture()" 
                      v-taurus-validator="'required'" />
          <div name="blacklistedDate" invalidfeedback="Please provide the date that you requested the gadget to be blacklisted"></div>
          <!-- v-taurus-validator="'required_if:deviceBlacklistRequested,true'" -->
        </div>
      </transition>

      <form-yes-no-radio-list 
          class="bumper"
          id="deviceReported" 
          v-model="deviceReported" 
          label="Was the incident reported to the police?"
          validationFieldLabel="deviceReported"
          validationInvalidFeedback="Please indicate whether you have reported the incident">
        </form-yes-no-radio-list>
       
      <transition name="fade" mode="in-out">
        <div v-if="deviceReported === true">
          <label for="reportedDate">Date the incident was reported</label>
          <datepicker id="reportedDate" 
                      fieldlabel="Reported date" 
                      :format="customDateFormatter" 
                      v-model="deviceReportedDate" 
                      :disabled-dates="disabledDatesInFuture()" 
                      v-taurus-validator="'required_if:deviceReported,true'"/>
          <div name="reportedDate" invalidfeedback="Please provide the date that you reported the incident"></div>
          
          <label for="policeStationAddress">Address of the police station where reported</label>
          <input type="text" 
                 id="policeStationAddress" 
                 fieldlabel="Police Station Address" 
                 v-model="devicePoliceAddress" 
                 v-taurus-validator="'required_if:deviceReported,true'"
                 class="form-control form-control-lg">
          <div name="policeStationAddress" invalidfeedback="Please provide the Police station address where you reported the incident"></div>
          
          <label for="crimeReference">Crime number / other reference</label>
          <input type="text" 
                 id="crimeReference" 
                 fieldlabel="Crime Reference" 
                 v-model="deviceCrimeRef" 
                 v-taurus-validator="'required_if:deviceReported,true'"
                 class="form-control form-control-lg" >
          <div name="crimeReference" invalidfeedback="Please provide the crime number or any other reference you have"></div>
            
        </div>
      </transition>
    </div> <!-- TL -->

    <form-yes-no-radio-list 
          class="bumper"
          id="devicePolicyholderPossession" 
          v-model="devicePolicyholderPossession" 
          label="Was the gadget in the possesion of the policyholder?"
          validationFieldLabel="devicePolicyholderPossession"
          validationInvalidFeedback="Please indicate whether the device was in the possesion of the policyholder when the incident happened">
        </form-yes-no-radio-list>
    

    <br />

    <transition name="fade">
      <div v-if="devicePolicyholderPossession != null && devicePolicyholderPossession == false"> <!-- Possesion details if not policyholder -->
        <span><strong>If you answered NO to the above please fill in the details of the person who had possesion of the gadget.</strong></span> <br /><br />
        <label for="possessionRelationshipId">Their relationship to you</label>
        <select id="possessionRelationshipId" 
                fieldlabel="Possession Relationship"
                class="form-control form-control-lg" 
                v-model="possessionRelationshipId" 
                v-taurus-validator="'required_if:devicePolicyholderPossession,false'" >
          <option :value="null">SELECT...</option>
          <option v-for="(option, index) in relationshipTypes" :key="'possessionRelationship_' + index" :value="option.id">
            {{option.label}}
          </option>
        </select>
        <div name="possessionRelationshipId" invalidfeedback="Please select the relationship of the person who had possession of the gadget at the time of the incident"></div>

        <label for="possessionTitle">Title</label>
        <select id="possessionTitle" 
                fieldlabel="Possession Title"  
                v-model="possessionTitle" 
                v-taurus-validator="'required_if:devicePolicyholderPossession,false'"
                class="form-control form-control-lg" >
          <option :value="null">SELECT...</option>
          <option v-for="(option, index) in titleTypes" :key="'titleType_' + index" :value="option.label">
            {{option.label}}
          </option>
        </select>
        <div name="possessionTitle" invalidfeedback="Please select their title"></div>        

        <label for="possessionFirstname">First name</label>
        <input type="text" 
               id="possessionFirstname" 
               fieldlabel="Possession Firstname" 
               v-model="possessionFirstname" 
               v-taurus-validator="'required_if:devicePolicyholderPossession,false'" 
               class="form-control form-control-lg">
        <div name="possessionFirstname" invalidfeedback="Please provide their first name"></div>

        <label for="possessionLastname">Last name</label>
        <input type="text" 
               id="possessionLastname" 
               fieldlabel="Possession Lastname" 
               v-model="possessionLastname" 
               v-taurus-validator="'required_if:devicePolicyholderPossession,false'"
               class="form-control form-control-lg">
        <div name="possessionLastname" invalidfeedback="Please provide their last name"></div>

        <label for="possessionEmail">Email</label>
        <input type="text" 
               id="possessionEmail" 
               class="form-control form-control-lg"
               fieldlabel="Possession Email" 
               v-model="possessionEmail" 
               v-taurus-validator="'required_if:devicePolicyholderPossession,false'">
        <div name="possessionEmail" invalidfeedback="Please provide their email"></div>

        <label for="possessionTel">Telephone</label>
        <input type="text" 
               id="possessionTel" 
               fieldlabel="Possession Telephone" 
               class="form-control form-control-lg"
               v-model="possessionTel" 
               v-taurus-validator="'required_if:devicePolicyholderPossession,false'">
        <div name="possessionTel" invalidfeedback="Please enter their telephone number"></div>

        <div class="form-group">
          <label for="possessionAddressLine1">Address</label>
          <input type="text" 
                id="possessionAddressLine1" 
                fieldlabel="Possession Address line 1"
                class="form-control form-control-lg" 
                v-model="possessionAddressLine1" 
                v-taurus-validator="'required_if:devicePolicyholderPossession,false'">
          <div name="possessionAddressLine1" invalidfeedback="Please enter the first line of their address"></div>
          <input type="text" 
                 id="possessionAddressLine2" 
                 fieldlabel="Possession Address line 2"
                 class="form-control form-control-lg"
                 v-model="possessionAddressLine2">
          <div name="possessionAddressLine2"></div>
          <label for="possessionAddressCity">Town / City</label>
          <input type="text" 
                 id="possessionAddressCity" 
                 fieldlabel="Possession Address City" 
                 class="form-control form-control-lg"
                 v-model="possessionAddressCity"
                 v-taurus-validator="'required_if:devicePolicyholderPossession,false'">
          <div name="possessionAddressCity" invalidfeedback="Please enter the town / city of their address"></div>
          <label for="possessionAddressCounty">County</label>
          <input type="text" 
                 id="possessionAddressCounty" 
                 fieldlabel="Possession Address County"
                 class="form-control form-control-lg" 
                 v-model="possessionAddressCounty"
                 v-taurus-validator="'required_if:devicePolicyholderPossession,false'">
          <div name="possessionAddressCounty" invalidfeedback="Please enter the county of their address"></div>
          <label for="possessionAddressPostcode">Postcode</label>
          <input type="text" 
                 id="possessionAddressPostcode" 
                 fieldlabel="Possession Address Postcode"
                 class="form-control form-control-lg" 
                 v-model="possessionAddressPostcode"
                 v-taurus-validator="'required_if:devicePolicyholderPossession,false'">
          <div name="possessionAddressPostcode" invalidfeedback="Please enter the postcode of their address"></div>
        </div>

      </div> <!-- Possesion details if not policyholder -->
    </transition>

    <br /><br />

    <transition name="fade">
          <div
              v-if="showErrorHelpMsg"
              class="text-danger mb-5">
              <i class="fas fa-exclamation-triangle mr-2"></i><strong>There seems to be a problem with the details you have provided, please check above.</strong>
          </div>
      </transition>
    <form-alert :show="claimFormSaveMsg && claimFormSaveMsg.length > 0" :flavour="1" :resellerId="resellerIdAsNumber">{{claimFormSaveMsg}}</form-alert>
    <form-button-bar
        :back_button_enable='true'
        :back_button_show='true'
        :back_button_icon_enable='true'
        :back_button_action='() => $router.go(-1)'
        :save_button_enable='true'
        :save_button_show='true'
        :save_button_icon_enable='true'
        :save_button_action='handleSaveClick'
        :next_button_enable='true'
        :next_button_show='true'
        :next_button_icon_enable='true'
        :next_button_action='handleNextClick' />
</form-container>
</div>
</template>

<script>

import tigaClaimForm from '@/mixins/tigaClaimForm'

import { GadgetAPI } from '@/services/gadget-api.service'
import FormContainer from '@/components/FormContainer.vue'
import FormAlert from '@/components/FormAlert.vue'
import FormImei from '@/components/FormIMEI.vue'
import FormSim from '@/components/FormSIM.vue'
import FormButtonBar from '@/components/standaloneForm/FormButtonBar.vue'

import datepicker from '@/components/taurus-datepicker/components/Datepicker.vue'

import CharCount from '@/components/CharCount.vue'
import FormTextArea from '@/components/FormTextArea.vue'
import FormYesNoRadioList from '@/components/FormYesNoRadioList.vue'
import FormGadgetDamageCheckList from '@/components/FormGadgetDamageCheckList.vue'

import moment from 'moment'

const chunk = (arr, chunkSize, cache = []) => {
  const tmp = [...arr]
  while (tmp.length) cache.push(tmp.splice(0, chunkSize))
  return cache
}

let initGadget = {
  itemGUID: '',
  deviceTypeId: null,
  deviceMakeId: null,
  deviceMakeLabel: '',
  deviceModelId: null,
  deviceModelLabel: '',
  newIMEI: null,
  originalIMEI: null,
  deviceIMEI: '',
  devicePurchaseDate: '',
  blacklistRequested: '',
  dateOfBlacklist: '',
  reportedToPolice: '',
  reportedToPoliceDate: '',
  policeStationAddress: '',
  policeCrimeReference: '',
  devicePolicyholderPossession: null,
  possessionDetails: {
    // relationshipTypeId: '',
    // relationshipTypeLabel: '',
    relationshipId: null,
    relationshipLabel: '',
    relationshipFreeText: '',
    title: null,
    firstname: '',
    lastname: '',
    email: '',
    telephone: '',
    address: {
      line1: '',
      line2: '',
      city: '',
      county: '',
      postcode: ''
    }
  },
  purchaseTypeLabel: '',
  purchaseTypeId: null,
  networkProviderId: null,
  networkProviderLabel: null,
  contractTypeId: null,
  contractTpeLabel: null,
  deviceReported: null,
  confirmIMEI: null,
  selectedDamageTypes: [],
  damageDescription: null,
  deviceSwitchOn: null,
  deviceLayFlat: null,
  relationshipTypeId: null,
  relationshipTypeLabel: null,
  purchasedBy: null,
  purchasedByPolicyHolder: null,
  devicePurchaseLocation: '',
  deviceDescription: '',
  deviceLocation: ''
}
let getOptionLabel = (options, idProp, idValue, valueProp) => {
  if (options && options.length > 0) {
    let option = options.find(i => { return i[idProp] == idValue })
    if (option) {
      return option[valueProp]
    }
  }
  return null
}

let required = (value) => {
  return !(value === undefined || value === null || value === '')
}

let atLeastOne = (value) => {
  return value && value.length > 0
}

export default {
  name: 'gadgetDetails',
  mixins: [
    tigaClaimForm,
  ],
  components: {
    FormContainer,
    FormAlert,
    FormImei,
    FormSim,
    FormButtonBar,
    datepicker,
    CharCount,
    FormTextArea,
    FormYesNoRadioList,
    FormGadgetDamageCheckList
  },
  data () {
    return {
      selectedDeviceIndex: 0,

      purchaseTypes: [
        {
          id: 1015,
          listId: 1002,
          label: 'New',
          description: '',
          sequence: 1,
          allowFreeText: false
        },
        {
          id: 1016,
          listId: 1002,
          label: 'Refurbished',
          description: '',
          sequence: 2,
          allowFreeText: false
        },
        {
          id: 1017,
          listId: 1002,
          label: 'Second Hand',
          description: '',
          sequence: 3,
          allowFreeText: false
        },
        {
          id: 1018,
          listId: 1002,
          label: 'Gifted',
          description: '',
          sequence: 4,
          allowFreeText: false
        }
      ],
      networkProviders: [
        { id: 1000, listId: 1000, label: 'O2', description: '', sequence: 1, allowFreeText: false },
        { id: 1001, listId: 1000, label: 'EE', description: '', sequence: 2, allowFreeText: false },
        { id: 1002, listId: 1000, label: 'Three Mobile', description: '', sequence: 3, allowFreeText: false },
        { id: 1003, listId: 1000, label: 'Vodaphone', description: '', sequence: 4, allowFreeText: false },
        { id: 1004, listId: 1000, label: 'Virgin', description: '', sequence: 5, allowFreeText: false },
        { id: 1005, listId: 1000, label: 'giffgaff', description: '', sequence: 6, allowFreeText: false },
        { id: 1006, listId: 1000, label: 'Tesco Mobile', description: '', sequence: 7, allowFreeText: false },
        { id: 1007, listId: 1000, label: 'Orange', description: '', sequence: 8, allowFreeText: false },
        { id: 1008, listId: 1000, label: 'T Mobile', description: '', sequence: 9, allowFreeText: false },
        { id: 1009, listId: 1000, label: 'BT', description: '', sequence: 10, allowFreeText: false },
        { id: 1010, listId: 1000, label: 'Talk Talk', description: '', sequence: 11, allowFreeText: false },
        { id: 1011, listId: 1000, label: 'Talk Mobile', description: '', sequence: 12, allowFreeText: false },
        { id: 1012, listId: 1000, label: 'Other', description: '', sequence: 13, allowFreeText: true }
      ],
      contractTypes: [
        { id: 1013, listId: 1001, label: 'Monthly Contract', description: '', sequence: 1, allowFreeText: false },
        { id: 1014, listId: 1001, label: 'Pay As You Go', description: '', sequence: 2, allowFreeText: false }
      ],

      relationshipTypes: [
        {
          id: 1000,
          label: 'Spouse/Partner'
        },
        {
          id: 1001,
          label: 'Son or Daughter'
        },
        {
          id: 1002,
          label: 'Other Relative'
        },
        {
          id: 1003,
          label: 'Friend'
        },
        {
          id: 1004,
          label: 'Work Colleague'
        },
        {
          id: 1005,
          label: 'Other'
        }
      ],

      titleTypes: [
        {
          id: 1000,
          label: 'Mr'
        },
        {
          id: 1001,
          label: 'Mrs'
        },
        {
          id: 1002,
          label: 'Miss'
        },
        {
          id: 1003,
          label: 'Ms'
        },
        {
          id: 1004,
          label: 'Dr'
        }
      ],

      damageTypes: [],

      nextAttempted: false,

      //localGadget: Object.assign({}, initGadget),
      localGadget: {
        itemGUID: '',
        deviceTypeId: null,
        deviceMakeId: null,
        deviceMakeLabel: '',
        deviceModelId: null,
        deviceModelLabel: '',
        newIMEI: null,
        originalIMEI: null,
        deviceIMEI: '',
        devicePurchaseDate: '',
        blacklistRequested: '',
        dateOfBlacklist: '',
        reportedToPolice: '',
        reportedToPoliceDate: '',
        policeStationAddress: '',
        policeCrimeReference: '',
        devicePolicyholderPossession: null,
        possessionDetails: {          
          relationshipId: null,
          relationshipLabel: '',
          relationshipFreeText: '',
          title: null,
          firstname: '',
          lastname: '',
          email: '',
          telephone: '',
          address: {
            line1: '',
            line2: '',
            city: '',
            county: '',
            postcode: ''
          }
        },
        purchaseTypeLabel: '',
        purchaseTypeId: null,
        networkProviderId: null,
        networkProviderLabel: null,
        contractTypeId: null,
        contractTpeLabel: null,
        deviceReported: null,
        confirmIMEI: null,
        selectedDamageTypes: [],
        damageDescription: null,
        deviceSwitchOn: null,
        deviceLayFlat: null,
        relationshipTypeId: null,
        relationshipTypeLabel: null,
        purchasedBy: null,
        purchasedByPolicyHolder: null,
        devicePurchaseLocation: '',
        deviceDescription: '',
        deviceLocation: '',
        simInDevice: null,
        reasonForNoSim: null,
        everUsedWithSim: null,
        lastUsedWithSimDate: null,
        lastUsedDate: null
      }
    }
  },
  watch: {
    confirmIMEI: function (val) {
      if (val == true) {
        this.deviceIMEI = this.originalIMEI
      } else {
        if (this.newIMEI) {
          this.deviceIMEI = this.newIMEI
        }
      }
    },
    selectedGadget: function (newVal) {
      console.log('selectedGadget: ', newVal)
    }
  },
  computed: {
    forceNewIMEI () {
      return this.originalIMEI ? false : true 
    },
    damageTypeClass() {
      let klass = {}
      klass['invalid-feedback'] = true;
      klass['d-block'] = this.nextAttempted && !this.isSelectedDamageTypesValid;
      return klass
    },
    selectedGadget: {
      get () {
        return this.$store.state.claimform.selectedGadget
      },
      set (value) {
        this.$store.commit('claimform/setSelectedGadget', value)
      }
    },
    simObj: {
      get () {
        if (this.localGadget) {
          let { simInDevice,
            reasonForNoSim,
            everUsedWithSim,
            lastUsedWithSimDate,
            lastUsedDate} = this.localGadget

          const obj = {
              simInDevice,
              reasonForNoSim,
              everUsedWithSim,
              lastUsedWithSimDate,
              lastUsedDate
          }
          return obj
        }
        return null
      },
      set (value) {
        if (value) {
            if (value.hasOwnProperty('simInDevice')) {
                this.localGadget.simInDevice = value['simInDevice']
            }
            if (value.hasOwnProperty('reasonForNoSim')) {
                this.localGadget.reasonForNoSim = value['reasonForNoSim']
            }
            if (value.hasOwnProperty('everUsedWithSim')) {
                this.localGadget.everUsedWithSim = value['everUsedWithSim']
            }
            if (value.hasOwnProperty('lastUsedWithSimDate')) {
                this.localGadget.lastUsedWithSimDate = value['lastUsedWithSimDate']
            }
            if (value.hasOwnProperty('lastUsedDate')) {
                this.localGadget.lastUsedDate = value['lastUsedDate']
            }
        }
      }
    },
    deviceDescription: {
      get () {
        return this.localGadget.deviceDescription
      },
      set (value) {
        this.localGadget.deviceDescription = value
      }
    },
    confirmIMEI: {
      get () {
        return this.localGadget.confirmIMEI
      },
      set (value) {
        this.localGadget.confirmIMEI = value
      }
    },
    deviceIMEI: {
      get () {
        return this.localGadget.deviceIMEI
      },
      set (value) {
        this.localGadget.deviceIMEI = value
      }
    },
    originalIMEI: {
      get () {
        return this.localGadget.originalIMEI
      },
      set (value) {
        this.localGadget.originalIMEI = value
      }
    },
    newIMEI: {
      get () {
        return this.localGadget.newIMEI
      },
      set (value) {
        this.localGadget.newIMEI = value
        this.localGadget.deviceIMEI = value
      }
    },
    isNewDeviceIMEIValid () {
      if (this.newIMEI) {
        return required(this.newIMEI)
      }
      return false
    },
    deviceSerial: {
      get () {
        return this.localGadget.deviceSerial
      },
      set (value) {
        this.localGadget.deviceSerial = value
      }
    },
    networkProviderId: {
      get () {
        return this.localGadget.networkProviderId
      },
      set (value) {
        this.localGadget.networkProviderId = value
        this.localGadget.networkProviderLabel = getOptionLabel(this.networkProviders, 'id', value, 'label')
      }
    },
    contractTypeId: {
      get () {
        return this.localGadget.contractTypeId
      },
      set (value) {
        this.localGadget.contractTypeId = value
        this.localGadget.contractTypeLabel = getOptionLabel(this.contractTypes, 'id', value, 'label')
      }
    },
    devicePurchaseLocation: {
      get () {
        return this.localGadget.devicePurchaseLocation
      },
      set (value) {
        this.localGadget.devicePurchaseLocation = value
      }
    },
    purchasedByPolicyHolder: {
      get () {
        return this.localGadget.purchasedByPolicyHolder
      },
      set (value) {
        this.localGadget.purchasedByPolicyHolder = value
      }
    },
    purchaseTypeId: {
      get () {
        return this.localGadget.purchaseTypeId
      },
      set (value) {
        this.localGadget.purchaseTypeId = value
        this.localGadget.purchaseTypeLabel = getOptionLabel(this.purchaseTypes, 'id', value, 'label')
      }
    },
    purchasedBy: {
      get () {
        return this.localGadget.purchasedBy
      },
      set (value) {
        this.localGadget.purchasedBy = value
      }
    },
    relationshipTypeId: {
      get () {
        return this.localGadget.relationshipTypeId
      },
      set (value) {
        this.localGadget.relationshipTypeId = value
        this.localGadget.relationshipTypeLabel = getOptionLabel(this.relationshipTypes, 'id', value, 'label')
      }
    },
    selectedDamageTypes: {
      get () {
        //return this.localGadget.selectedDamageTypes
        return this.selectedGadget.selectedDamageTypes
      },
      set (value) {
        //this.localGadget.selectedDamageTypes = value
        this.selectedGadget.selectedDamageTypes = value
      }
    },
    isSelectedDamageTypesValid () {
      return atLeastOne(this.selectedDamageTypes)
    },
    damageDescription: {
      get () {
        return this.localGadget.damageDescription
      },
      set (value) {
        this.localGadget.damageDescription = value
      }
    },
    deviceSwitchOn: {
      get () {
        return this.localGadget.deviceSwitchOn
      },
      set (value) {
        this.localGadget.deviceSwitchOn = value
      }
    },
    deviceLayFlat: {
      get () {
        return this.localGadget.deviceLayFlat
      },
      set (value) {
        this.localGadget.deviceLayFlat = value
      }
    },
    deviceLocation: {
      get () {
        return this.localGadget.deviceLocation
      },
      set (value) {
        this.localGadget.deviceLocation = value
      }
    },
    devicePolicyholderPossession: {
      get () {
        return this.localGadget.devicePolicyholderPossession
      },
      set (value) {
        this.localGadget.devicePolicyholderPossession = value
      }
    },
    deviceBlacklistRequested: {
      get () {
        return this.localGadget.blacklistRequested
      },
      set (value) {
        this.localGadget.blacklistRequested = value
      }
    },
    deviceBlacklistDate: {
      get () {
        return this.localGadget.dateOfBlacklist
      },
      set (value) {
        this.localGadget.dateOfBlacklist = value
      }
    },
    deviceReported: {
      get () {
        return this.localGadget.reportedToPolice
      },
      set (value) {
        this.localGadget.reportedToPolice = value
      }
    },
    deviceReportedDate: {
      get () {
        return this.localGadget.reportedToPoliceDate
      },
      set (value) {
        this.localGadget.reportedToPoliceDate = value
      }
    },
    devicePoliceAddress: {
      get () {
        return this.localGadget.policeStationAddress
      },
      set (value) {
        this.localGadget.policeStationAddress = value
      }
    },
    deviceCrimeRef: {
      get () {
        return this.localGadget.policeCrimeReference
      },
      set (value) {
        this.localGadget.policeCrimeReference = value
      }
    },
    possessionTitle: {
      get () {
        return this.localGadget.possessionDetails.title
      },
      set (value) {
        this.localGadget.possessionDetails.title = value
      }
    },
    possessionFirstname: {
      get () {
        return this.localGadget.possessionDetails.firstname
      },
      set (value) {
        this.localGadget.possessionDetails.firstname = value
      }
    },
    possessionLastname: {
      get () {
        return this.localGadget.possessionDetails.lastname
      },
      set (value) {
        this.localGadget.possessionDetails.lastname = value
      }
    },
    possessionEmail: {
      get () {
        return this.localGadget.possessionDetails.email
      },
      set (value) {
        this.localGadget.possessionDetails.email = value
      }
    },
    possessionTel: {
      get () {
        return this.localGadget.possessionDetails.telephone
      },
      set (value) {
        this.localGadget.possessionDetails.telephone = value
      }
    },
    possessionRelationshipId: {
      get () {
        return this.localGadget.possessionDetails.relationshipId
      },
      set (value) {
        if (value != 'SELECT...') {
          this.localGadget.possessionDetails.relationshipId = value
          let typesFilter = this.relationshipTypes.filter(r => r.id == value)
          if (typesFilter && typesFilter.length > 0) {
            this.localGadget.possessionDetails.relationshipLabel = typesFilter[0].label
          }
        }
      }
    },
    possessionAddressLine1: {
      get () {
        return this.localGadget.possessionDetails.address.line1
      },
      set (value) {
        this.localGadget.possessionDetails.address.line1 = value
      }
    },
    possessionAddressLine2: {
      get () {
        return this.localGadget.possessionDetails.address.line2
      },
      set (value) {
        this.localGadget.possessionDetails.address.line2 = value
      }
    },
    possessionAddressCity: {
      get () {
        return this.localGadget.possessionDetails.address.city
      },
      set (value) {
        this.localGadget.possessionDetails.address.city = value
      }
    },
    possessionAddressPostcode: {
      get () {
        return this.localGadget.possessionDetails.address.postcode
      },
      set (value) {
        this.localGadget.possessionDetails.address.postcode = value
      }
    },
    possessionAddressCounty: {
      get () {
        return this.localGadget.possessionDetails.address.county
      },
      set (value) {
        this.localGadget.possessionDetails.address.county = value
      }
    },
    devicePurchaseDate: {
      get () {
        return this.localGadget.devicePurchaseDate
      },
      set (value) {
        this.localGadget.devicePurchaseDate = value
      }
    },
    gadgetTypePhone () {
      if (this.selectedGadget) {
        return this.selectedGadget.deviceTypeId == 1
      }
    },
    incidentTypeId () {
      if (this.$store.state.claimform.claimForm.data.incident) {
        return this.$store.state.claimform.claimForm.data.incident.incidentTypeId
      }

      return 0
    },
    incidentTypeADOrMB () {
      let incidentTypes = [1000, 1003, 1004, 1005, 1006]
      return incidentTypes.includes(this.incidentTypeId)
    },
    incidentTypeTL () {
      let incidentTypes = [1001,1002,1007,1008,1009,1010,1011,1012,1013,1014]
      return incidentTypes.includes(this.incidentTypeId)
    },
    deviceLabel () {
      if (this.selectedGadget) {
        return `${this.selectedGadget.deviceMakeLabel} / ${this.selectedGadget.deviceModelLabel}`
      }
    },
    damageTypesChunked () {
      if (this.damageTypes && this.damageTypes.length > 0) {
        let chunkSize = Math.ceil(this.damageTypes.length / 2)
        return chunk(this.damageTypes, chunkSize)
      }
    },
    showErrorHelpMsg () {
      if (this.nextAttempted) {
        return !this.checkForm()
      } else {
        return false
      }
    }
  },
  mounted() {

    if (!this.claimformHasPolicyNumber || 
      !this.claimformHasClaimant || 
      !this.claimformHasIncidentType || 
      !this.claimformHasClaimantUKRes ||
      !this.claimformHasClaimantVATReg ||
      !this.claimformHasIncidentDetails ||
      !this.claimformHasGadgets) {
      this.gotoStage1();
    }

    if(this.$route.params.id) {
      this.selectedDeviceIndex = this.$route.params.id;
    }
    
    if (!this.originalIMEI) {
      this.originalIMEI = this.deviceIMEI
    }

    if (this.damageTypes && this.damageTypes.length == 1) {
        console.log('damageTypes: ', this.damageTypes)
        this.handleDamageTypeClick(this.damageTypes[0])
    }

    //console.log('')
  },
  beforeMount () {
    
    this.localGadget = this.selectedGadget
    
    this.fetchDamageTypes()
  },
  methods: {
    deviceSerialIMEI (device) {
      if (device.imeiNo) {
        return ` - IMEI [${device.imeiNo}]`
      }

      if (device.serialNo) {
        return ` - Serial [${device.serialNo}]`
      }
    },
    showClaimForDevice (device) {
      var found = this.gadgets.find(g => g.itemGUID == device.itemGUID)
      if (found) {
        return false
      } else {
        return true
      }
    },
    deviceInSelectedDevices (device) {
      let index = arrContainsObject(device, this.selectedDevices)

      if (index == -1) {
        return false
      } else {
        return true
      }
    },
    isGadgetInSelectedDevices (gadget) {
      return this.gadgetIndexByItemGUID(gadget.itemGUID) != -1
    },
    fetchDamageTypes () {
      GadgetAPI.getDamageTypes(this.selectedGadget.deviceTypeId, this.selectedIncidentTypeId)
        .then(res => {
          let apiRes = res.data
          if (apiRes) {
            this.damageTypes = apiRes.data
          }
        })
        .catch(err => {

        })
        .finally()
    },
    handleDamageTypeClick (selectedDamageType) {
      let index = -1

      for (var i = 0; i < this.selectedDamageTypes.length; i++) {
        if (this.selectedDamageTypes[i].id === selectedDamageType.id) {
          index = i
        }
      }

      if (index == -1) {
        this.selectedDamageTypes.push(selectedDamageType)
      } else {
        this.selectedDamageTypes.splice(index, 1)
      }

      this.$emit('input', this.selectedDamageTypes)
    },
    isDamageTypeSelected (damageType) {
      for (var i = 0; i < this.selectedDamageTypes.length; i++) {
        if (this.selectedDamageTypes[i].id === damageType.id) {
          return true
        }
      }
      return false
    },
    disabledDatesInFuture () {
      return {
        from: new Date()
      }
    },
    customDateFormatter (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    handleNextClick () {
      
      this.addUpdateGadget(this.selectedGadget)
      this.nextAttempted = true      
      let formValid = false
      if (this.incidentTypeADOrMB) {
        formValid = this.checkForm() /*&& this.isSelectedDamageTypesValid*/
      } else {
        formValid = this.checkForm()
      }
      
     
      if (formValid) {
        if (this.gadgets.length > 1 && this.selectedDeviceIndex < (this.gadgets.length - 1)) {
          this.selectedDeviceIndex = parseInt(this.selectedDeviceIndex) + parseInt(1)

          //this.selectedGadget = Object.assign({}, this.gadgets[ this.selectedDeviceIndex])
          this.selectedGadget = this.gadgets[ this.selectedDeviceIndex]
          this.$router.push({ path: '/makeaclaim/101/' + this.selectedDeviceIndex});
                    
        } else {
          this.$router.push({ name: 'supportingDocs' })
        }
      }

      this.nextAttempted = true
    },
    handleSaveClick () {
      this.addUpdateGadget(this.selectedGadget)
      this.saveClaimForm()
    },
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>